module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row-section",
    style: (_vm.cssVars)
  }, [_c('div', {
    staticClass: "container",
    class: _vm.containerClasses
  }, [_c('div', {
    staticClass: "row justify-content-around"
  }, [_c('div', {
    staticClass: "col-md-5 img-wrapper",
    class: {
      'order-md-2': _vm.flipImage
    }
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imagePaths.mobile),
      expression: "imagePaths.mobile"
    }],
    staticClass: "d-block d-sm-none",
    attrs: {
      "alt": _vm.altText
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imagePaths.desktop),
      expression: "imagePaths.desktop"
    }],
    staticClass: "d-none d-sm-block",
    attrs: {
      "alt": _vm.altText
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 d-flex flex-column justify-content-md-center"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._t("content")], 2), _vm._v(" "), _c('div', {
    staticClass: "row mx-0 below-text-content"
  }, [_vm._t("button-contact")], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-98240434"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/industries/RowSection.vue
// module id = 2001
// module chunks = 5